/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { exactly } from 'purify-ts/Codec';
import { UIPrefsStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var Theme;
(function (Theme) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.PREF_NAME = 'theme';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.codec = exactly('light', 'dark', 'auto');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.DEFAULT_VALUE = 'auto';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.load = () => UIPrefsStore.loadUIPreference({ preference: Theme.PREF_NAME });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.set = (value) => UIPrefsStore.patchUIPreference({
        preference: Theme.PREF_NAME,
        value,
    });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    Theme.get = () => {
        const pref = UIPrefsStore.getUIPref()(Theme.PREF_NAME, Theme.codec);
        const status = pref.status;
        switch (status) {
            case 'not-loaded':
            case 'not-present':
                return Theme.DEFAULT_VALUE;
            case 'not-valid':
                return Theme.DEFAULT_VALUE;
            case 'valid':
                return pref.value;
            default:
                throw utils.AssertionError.assertNever(status);
        }
    };
})(Theme || (Theme = {}));
